<template>
  <div class="prompt">
    <div class="prompt-label">
      {{ modalStore.modalObj.promptLabel }}
    </div>
    <div class="prompt-description">
      <span v-html="modalStore.modalObj.promptDescription" />
    </div>

    <div class="prompt-input"
         v-if="modalStore.modalObj.showInput"
        @click="handlePromptClick"
    >
      <div class="file-type">
        <img
            :src="require('@/assets/svg/SVG/yt.svg')"
            alt="YouTube"
            Link
        >
      </div>
      <div class="file-type pdf">
        <img
            :src="require('@/assets/svg/SVG/pdf.svg')"
            alt="PDF"
            Link
        >
      </div>
      <input
          ref="linkAsset"
          class="paste-url"
          placeholder="PASTE URL HERE"
      >
    </div>

    <div class="button-holder">
      <div
        class="button"
        @click.stop="modalStore.modalObj.buttonAFunc"
      >
        {{ modalStore.modalObj.buttonALabel }}
      </div>
      <div v-if="modalStore.modalObj.buttonBFunc != null"
        class="button"
        @click.stop="modalStore.modalObj.buttonBFunc"
      >
        {{ modalStore.modalObj.buttonBLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import { useModalStore } from '@/store/ModalStore';
import { mapStores } from 'pinia';

export default {
  name: 'ModalPrompt',
  computed: {
    ...mapStores(useModalStore),
  },
  methods: {
    handlePromptClick (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  },
  props: [
      'obj'
  ]
};
</script>

<style scoped>


.file-type {
  width: 40px;
  margin-right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pdf {
  padding: 3px;
}

.paste-url {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23333' stroke-width='1' stroke-dasharray='6%2c6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  width: 100%;
  margin-right: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: .8em;
  font-weight: 500;
  letter-spacing: .05em;
}

.prompt {
  width: 350px;
  padding: 10px 20px;
  background-color: white;
  pointer-events: auto;
}
.button-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 5px;
}
.button {
  cursor: pointer;
  margin: 5px;
  padding: 10px 25px;
  color: white;
  font-weight: 700;
  font-size: .9em;
  text-transform: uppercase;
  background-color: var(--nelson-green);
}

.button:hover {
  background-color: #00a851;
}

.prompt-label {
  font-weight: bold;
  padding-top:10px;
  padding-bottom:10px;
}
.prompt-description {
  padding-bottom: 10px;
  font-size: .95em;
}

.prompt-input {
  height: 30px;
  display: flex;
  margin: 10px;

}
</style>
